import * as React from 'react';
import { ReactComponent as PillsIconSVG } from '../../assets/icons/mevo/ic_pills.svg';
import IconPattern, { IconProps } from './_IconPattern';

const PillsIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={PillsIconSVG} variantPlaces={[1, 2]} {...props} />;
};

export default PillsIcon;
